import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AgentMergeQueueGuardService } from '../services/agent-merge-queue-guard.service';
import { MergeInProgressAlertModalService } from '../components/merge-in-progress-alert-modal/merge-in-progress-alert-modal.service';

@Directive({
  selector: '[agMergeGuard]',
  exportAs: 'agMergeGuard',
})
export class MergeQueueGuardDirective {
  @Input('agMergeGuard') agentDbId?: string | null;
  @Input() agMergeGuardDisabled = false;
  @Output() agMergeGuardedClick = new EventEmitter<Event>();

  constructor(
    private agentMergeQueueGuardService: AgentMergeQueueGuardService,
    private mergeInProgressAlertModalService: MergeInProgressAlertModalService,
  ) {}

  @HostListener('click', ['$event'])
  async handleClick(event: Event): Promise<void> {
    if (this.agMergeGuardDisabled) {
      this.agMergeGuardedClick.emit(event);
      return;
    }

    const agentDbId = this.agentDbId ?? null;
    if (!agentDbId) {
      this.agMergeGuardedClick.emit(event);
      return;
    }

    try {
      const isBlocked = await this.agentMergeQueueGuardService.isAgentMergeBlocked(agentDbId);
      if (isBlocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.mergeInProgressAlertModalService.open();
        return;
      }
    } catch {
      // If guard fails, fall through to allow action.
    }

    this.agMergeGuardedClick.emit(event);
  }
}
